module.exports = __webpack_public_path__ + "static/media/agents-bg.7b2f3fbd.jpg";